// Expose https://momentjs.com
import moment from 'moment';

// Expose modules/javascript/www/common/formatters/date-formatter.
// Contains formatDate(), formatDateRange(), and localtime().
import * as DateFormatter from 'common/formatters/date-formatter';

// Expose modules/javascript/www/common/formatters/number-formatter.
// Contains formatNumber().
import * as NumberFormatter from 'common/formatters/number-formatter';

window.moment = moment;

window.formatters = window.formatters || {};
window.formatters.DateFormatter = DateFormatter;
window.formatters.NumberFormatter = NumberFormatter;
